module.exports = __webpack_public_path__ + "assets/img/tx111_4.1f2fee37.jpg";